import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useStoreListObject = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const storeMap = useMemo(() => {
    return (storeList || []).reduce((acc, store) => {
      acc[store.id] = store;
      return acc;
    }, {});
  }, [storeList]);

  return { storeMap };
};
